import React from "react";
import "./ReflectionHeader.css";
import { FollowingList } from "../../pages/settings/datasharing/DataSharingTypes";
import Avatar from "../ui/Avatar";

interface ReflectionHeaderProps {
  title?: string;
  subTitle?: string;
  notificationCount?: number;
  onNotificationClick?: () => void;
  onOpenFollowingModal?: (followingData: FollowingList[]) => void;
  followingData?: FollowingList[];
  avatars: { label: string; value: string }[];
}

const ReflectionHeader: React.FC<ReflectionHeaderProps> = ({
  title = "Reflections",
  subTitle = "",
  notificationCount = 0,
  onNotificationClick,
  onOpenFollowingModal,
  followingData = [],
  avatars,
}) => {
  return (
    <div className="app-header" style={{ position: "relative", zIndex: 10, marginBottom: '2rem' }}>
      <div className="header-content flex items-center justify-between">
        {/* Title */}
        <div className="user-greeting-container">
          <h1 className="greeting">{title}</h1>
          {subTitle && <p className="text-center text-white">{subTitle}</p>}
        </div>

        {/* Right side icons */}
        <div className="header-icons">
          {/* Notification Bell */}
          {onNotificationClick && (
            <div
              className="notification-container"
              onClick={onNotificationClick}
            >
              <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 11.75H15.5V13.25H0.5V11.75H2V6.5C2 3.18629 4.68629 0.5 8 0.5C11.3137 0.5 14 3.18629 14 6.5V11.75ZM12.5 11.75V6.5C12.5 4.01472 10.4853 2 8 2C5.51472 2 3.5 4.01472 3.5 6.5V11.75H12.5ZM5.75 14.75H10.25V16.25H5.75V14.75Z"
                  fill="white"
                />
              </svg>
              {notificationCount > 0 && (
                <span className="notification-badge">{notificationCount}</span>
              )}
            </div>
          )}

          {/* Stacked Avatars */}
          {followingData && followingData.length > 0 && (
            <div className="mt-0 mb-1 flex items-center justify-end pr-0">
              <div
                className="stacked-avatars-container"
                onClick={() => onOpenFollowingModal?.(followingData)}
              >
                <div className="flex -space-x-2">
                  {followingData
                    .slice(0, 3)
                    .map((follower: any, index: number) => (
                      <Avatar
                        key={follower?.id || index}
                        unstyled
                        imageSrc={follower?.profile?.avatar}
                        initials={(
                          follower?.profile?.first_name?.charAt(0) ||
                          follower?.profile?.username?.charAt(0) ||
                          follower?.profile?.email?.charAt(0) ||
                          follower?.profile?.phone?.charAt(0) ||
                          "U"
                        ).toUpperCase()}
                        className="w-8 h-8 md:w-12 md:h-12 rounded-full bg-[#007C9E] flex items-center justify-center text-white text-sm border-1 border-white"
                        innerClassName=""
                        imageClassName="w-8 h-8 md:w-12 md:h-12 rounded-full object-cover"
                      />
                    ))}
                </div>
                {followingData?.length > 3 && (
                  <div className="follower-count mx-1">
                    +{followingData?.length - 3}
                  </div>
                )}
                <div>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M11.06 5.52979L8 8.58312L4.94 5.52979L4 6.46979L8 10.4698L12 6.46979L11.06 5.52979Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReflectionHeader;